import { Component } from 'react';
import { connect } from 'react-redux';
import { NormalText, SmallText, Spacer, StrongText, Title } from '../../components/common';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { checkBackgroundColor, forwardTo, isEmptyObject } from '../../lib/utils';
import moment from 'moment';
import api from '../../lib/api';
import { Wheel } from 'react-custom-roulette';
import { getVouchers, showToast } from '../../store/actions';
import Confetti from 'react-confetti'

import { IonButton, IonIcon, IonSpinner } from '@ionic/react';
import Layout from '../../components/layout';
import { gift, giftOutline } from 'ionicons/icons';
import { getConfig } from '../../appConfig';

class VoucherGame extends Component {

    constructor(props) {
        super(props)
        this.state = {
            modalOpened: true,
            groupedVouchers: [],
            selectedVoucher: null,
            wheelData: null,
            mustSpin: false,
            prizeNumber: 0,
            borderColor: '#000000',
            rewardSelected: false,
            voucher: null,
            wheelLoading: false,
            hasIcon: false,
            bannerImageLoaded: false
        }
        this.groupedVouchersRef = {}

    }
    viewVoucher = async (selectedVoucher) => {
        try {
            const gameId = selectedVoucher.reward.game_config.game_campaign_id

            const data = await api.getGameVoucherPreview(gameId)
            this.setState({ selectedVoucher, wheelData: data.data })
        }
        catch (err) {
            this.setState({
                selectedVoucher: null, rewardSelected: false, prizeNumber: 0, mustSpin: false, gameWon: false, voucher: null, wheelLoading: false
            }, () => {
                forwardTo('/loyalty',{ scrollToVouchers: true })
                this.props.dispatch(showToast(this.props.__('An error occurred. Please try again'), 'warning'))

            })
        }

    };
    handleSlideChange = (index, group) => {
        const { __ } = this.props
        const wrapper = this.groupedVouchersRef?.[group]?.current
        const data = this.state.groupedVouchers?.[group]?.[index]
        if (wrapper) {
            wrapper.querySelector('.normal-text[data-attr="name"]').textContent = data.reward.name
            wrapper.querySelector('.normal-text[data-attr="expiry"]').textContent = `${__(`Expires`)} ${moment(data.expiry_date, 'YYYY/MM/DD').format('LL')}`
        }
    }
    getVoucherGroups = (data) => {
        const groups = Object.values(
            data.filter(el => el.is_game && !isEmptyObject(el.reward.game_config)).reduce((acc, item) => {
                const key = item.reward.id;
                if (!acc[key]) acc[key] = [];
                acc[key].push(item);
                return acc;
            }, {})
        );
        groups.forEach(group => {
            group.sort((a, b) =>
                moment(a.expiry_date) - moment(b.expiry_date)
            );
        });
        groups.sort((a, b) => {
            return moment(a[0].expiry_date) - moment(b[0].expiry_date);
        });

        return groups;
    };

    componentDidMount() {

        if (this.props.clientStyles.colors['--okx-spin-wheel-border-color']) {
            this.setState({ borderColor: this.props.clientStyles.colors['--okx-spin-wheel-border-color'] })
        }
        if (this.props.location?.state?.voucher) {
            this.viewVoucher(this.props.location.state.voucher)
        } else {
            forwardTo('/loyalty')

        }

    }
    formatWheelData = (segments) => {
        return segments.map(item => {
            const result = {
                option: item.label,
                style: {
                    backgroundColor: item.segment_color,
                },
                is_prize: item?.is_prize
            };
            if (item.icon_image) {
                if (!this.state.hasIcon) {
                    this.setState({ hasIcon: true })
                }
                result.image = {
                    uri: item.icon_image
                };
            }
            return result;
        });

    }


    handleSpinClick = () => {
        try {
            const { __ } = this.props
            const { selectedVoucher } = this.state
            const gameId = selectedVoucher.reward?.game_config?.game_campaign_id
            const voucherId = selectedVoucher.id
            this.setState({ wheelLoading: true }, async () => {
                try {
                    const result = await api.setGameVoucherSpin({
                        "game_voucher_id": voucherId,
                        "campaign_id": gameId

                    })
                    if (result.error) {
                        this.setState({ wheelLoading: false }, () => {
                            forwardTo('/loyalty')
                            this.props.dispatch(showToast(result.error.message, 'warning'))
                        })

                    } else {
                        this.setState({ mustSpin: true, prizeNumber: result.data.segment_index, result, wheelLoading: false })
                        if (result?.data) {
                            const reward = result.data
                            const vouchers = await api.getVouchers()
                            const voucher = vouchers.data.find(el => el.id == reward.voucher_id)
                            this.props.dispatch(getVouchers())
                            if (reward.won) {
                                this.setState({ rewardSelected: reward, gameWon: true, voucher, bannerImageLoaded: false })
                            } else {
                                this.setState({ rewardSelected: reward, gameWon: false, voucher, bannerImageLoaded: false })
                            }

                        } else {
                            this.setState({ wheelLoading: false }, () => {
                                forwardTo('/loyalty')
                                this.props.dispatch(showToast(__('An error occurred. Please try again'), 'warning'))
                            })

                        }

                    }
                } catch (err) {
                    const message = err.response?.data?.error?.message || 'An error occurred.'
                    this.setState({ wheelLoading: false }, () => {
                        forwardTo('/loyalty')
                        this.props.dispatch(showToast(message, 'warning'))
                    })
                }
            })

        } catch (err) {
            this.setState({ wheelLoading: false }, () => {
                if (err.response.data.error) {
                    forwardTo('/loyalty')

                    this.props.dispatch(showToast(err.response.data.error.message, 'warning'))
                }
            })

        }

    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.mustSpin && nextState.mustSpin) {
            return false
        }

        return true
    }
    render() {
        const { __ } = this.props;
        const { selectedVoucher, wheelData, mustSpin, prizeNumber, borderColor, rewardSelected, gameWon, wheelLoading, hasIcon, bannerImageLoaded } = this.state

        let data = []
        let colors = []
        if (wheelData) {
            data = this.formatWheelData(wheelData.segments)
            colors = data.map(el => checkBackgroundColor(el?.style?.backgroundColor ? el.style.backgroundColor : '#ffffff')).map(el => el == 'white' ? '#ffffff' : '#000000')
        }
        // A count mismatch would stop the pointer on the wrong prize: use the standard wheel instead.
        const wheelImage = wheelData?.custom_wheel?.segment_count === data.length ? wheelData.custom_wheel.image : null
        // Six full turns, then stop with the winning segment's centre under the top pointer.
        const spinRotation = this.state.result ? 2160 - (prizeNumber + 0.5) * 360 / data.length : 0

        return (
            <>
                < Layout
                    color="transparent"
                    backHandler={() => forwardTo('/loyalty', { scrollToVouchers: true })}
                >
                    <div className='absolute-content scrollable-y'>

                        {selectedVoucher && selectedVoucher.reward ? (
                            <>
                                {rewardSelected ? <div className='wheel-reward'>
                                    <div>
                                        {rewardSelected.result_banner_image && !bannerImageLoaded && (
                                            <>
                                                <img
                                                    src={rewardSelected.result_banner_image}
                                                    style={{ display: 'none' }}
                                                    onLoad={() => this.setState({ bannerImageLoaded: true })}
                                                />
                                                <IonSpinner color={'primary'} />
                                            </>
                                        )}
                                        {(!rewardSelected.result_banner_image || bannerImageLoaded) && <>
                                            {gameWon &&
                                                <Confetti numberOfPieces={300} recycle={false} />}
                                            <Spacer size={5} />
                                            <div className='title'
                                                dangerouslySetInnerHTML={{ __html: __(rewardSelected.result_message) }}
                                            ></div>
                                            <Spacer size={5} />
                                            <div>
                                                {rewardSelected.result_banner_image &&
                                                    <img src={rewardSelected.result_banner_image} />
                                                }
                                            </div>
                                            <Spacer size={5} />
                                            <IonButton style={{ width: '100%' }} onClick={() => {
                                                this.setState({
                                                    selectedVoucher: null, rewardSelected: false, prizeNumber: 0, mustSpin: false, gameWon: false, voucher: null, wheelLoading: false
                                                }, () => {
                                                    forwardTo('/loyalty', { scrollToVouchers: true })
                                                })
                                            }} expand='block' >{!gameWon ? __('OK') : __('My vouchers')}</IonButton>
                                        </>}
                                    </div>
                                </div> :
                                    <div >
                                        <Title >{wheelData.title ?? __('Voucher details')}</Title>
                                        <Spacer size={2} />


                                        <div className='wheel-wrapper' >
                                            <div>
                                                {wheelLoading &&
                                                    <div className='wheel-loader'>
                                                        <IonSpinner />
                                                        <StrongText>{__('We are preparing your game')}</StrongText>

                                                    </div>
                                                }
                                                {wheelImage ?
                                                    <div className='wheel-vector-wrapper'>
                                                        <div className='wheel-pointer' />
                                                        <div
                                                            className='wheel-vector'
                                                            style={{ transform: `rotate(${spinRotation}deg)` }}
                                                            onTransitionEnd={() => this.setState({ mustSpin: false })}
                                                        >
                                                            <img src={wheelImage} alt='' />
                                                            {data.map((el, index) => (
                                                                <span
                                                                    key={index}
                                                                    className='wheel-vector-label'
                                                                    style={{ color: colors[index], transform: `rotate(${(index + 0.5) * 360 / data.length - 90}deg)` }}
                                                                >
                                                                    {el.option}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div> :
                                                    <Wheel
                                                        mustStartSpinning={mustSpin}
    
                                                        prizeNumber={prizeNumber}
                                                        data={data}
                                                        outerBorderColor={[borderColor]}
                                                        outerBorderWidth={[5]}
                                                        radiusLineColor={[borderColor]}
                                                        radiusLineWidth={[5]}
                                                        textColors={colors}
                                                        textDistance={hasIcon ? 70 : 55}
                                                        onStopSpinning={() => {
                                                            this.setState({ mustSpin: false }, async () => {
    
    
                                                            });
                                                        }}
                                                    />
                                                }
                                            </div>

                                            <div onClick={() => this.handleSpinClick()} className='wheel-button '><SmallText className='bold'>{__('SPIN')}</SmallText></div>
                                        </div>
                                        <Spacer size={5} />

                                        <StrongText className='block label-color'>{__('How to play')}</StrongText>

                                        <Spacer size={3} />
                                        <NormalText className='block label-color'>{__('Tap the wheel to start spinning. If you land on a prize - Congratulations! Your reward will appear here for you to redeem.')}</NormalText>
                                        <Spacer size={2} />

                                        <NormalText className='block label-color'>{__('If you don’t win - bad luck, please play again!')}</NormalText>
                                        <Spacer size={2} />
                                        {!getConfig().flags.removeGameVoucherRewardsList &&
                                            <div className='wheel-legend'>
                                                {data.filter(el => el.is_prize).map((item, index) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                        >
                                                            {item?.image?.url ?
                                                                <img
                                                                    src={item.image.uri}
                                                                    alt={item.option}
                                                                    className="prize-image"
                                                                />
                                                                :
                                                                <IonIcon icon={giftOutline} />

                                                            }

                                                            <SmallText className='label-color'>
                                                                {item.option}
                                                            </SmallText>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        }



                                    </div>
                                }
                            </>
                        ) : null}
                    </div>

                </Layout >
            </>

        );
    }
}

const stateToProps = (state) => {


    return {

        clientStyles: state.common.clientStyles,


    };
};

export default connect(stateToProps)(withTranslation(VoucherGame));
